<script>
</script>

<div class="h-screen max-h-full w-screen max-w-full">
  <h1 class="text-center text-white text-3xl font-bold p-8">Loading...</h1>
</div>
